<template>
  <div class="suite-of-power bg-primary text-white py-20">
    <TypeDisplay
      :variant="$options.Typography.Display.GIGA"
      :weight="$options.Typography.Weights.STRONG"
      tag="p"
      class="font-bold text-white text-center mb-2"
    >
      <span v-text="title" />
    </TypeDisplay>
    <TypeHeading
      :variant="$options.Typography.Heading.TITLE"
      :weight="$options.Typography.Weights.REGULAR"
      tag="p"
      class="text-center text-white mb-8"
    >
      <span v-text="subtitle" />
    </TypeHeading>
    <div
      class="lg:max-w-5xl grid grid-cols-9 justify-items-center gap-2 mx-auto px-8"
    >
      <BaseCard
        v-for="(block, index) in blocks"
        :key="`suite-block-${index}`"
        class="max-w-xs col-span-12 md:col-span-3 mx-2"
        :full-bleed="true"
      >
        <div class="flex flex-col items-center text-black text-center p-6">
          <figure class="image mb-3 mt-2">
            <img :src="block.icon" class="icon w-10 h-10" />
          </figure>
          <TypeHeading
            :variant="$options.Typography.Heading.HEADLINE"
            :weight="$options.Typography.Weights.BOLD"
          >
            <p class="mb-2">{{ block.heading }}</p>
          </TypeHeading>
          <TypeBody
            :variant="$options.Typography.Body.TEXT"
            :weight="$options.Typography.Weights.REGULAR"
          >
            <div class="max-w-xs mx-auto" v-html="block.subheading"></div>
          </TypeBody>
        </div>
      </BaseCard>
    </div>
  </div>
</template>

<script>
import {
  constants,
  BaseCard,
  TypeBody,
  TypeDisplay,
  TypeHeading,
} from '@bambeehr/pollen';
import { defineComponent } from '@nuxtjs/composition-api';
const { Typography } = constants;
export default defineComponent({
  name: 'SuiteOfPower',
  Typography,
  components: { BaseCard, TypeBody, TypeDisplay, TypeHeading },
  setup() {
    const title = `A Suite of Powerful Services`;
    const subtitle = `Included When you Join Bambee`;
    const blocks = [
      {
        icon: '/assets/information/reviews/pen-write.svg',
        heading: 'Internal HR Policies',
        subheading:
          '<p>We’ll work with you to craft your internal HR policies that fit the way you run your&nbsp;business.</p>',
      },
      {
        icon: '/assets/information/reviews/teacher.svg',
        heading: 'Train Your Staff',
        subheading:
          '<p>Good HR practices start from within. We’ll help train your staff to follow the internal policies at your&nbsp;company.</p>',
      },
      {
        icon: '/assets/information/reviews/strategy.svg',
        heading: 'Coaching & Questions',
        subheading:
          '<p>Full remote HR support, available to help by phone, email, or chat. Consider us an extension of your&nbsp;team.</p>',
      },
    ];

    return {
      title,
      subtitle,
      blocks,
    };
  },
});
</script>
